import { createSlice } from '@reduxjs/toolkit';

/**
 *
 * @type CountryStoreCountry
 */
const initialState = {
  countryList: { loading: false, data: null, error: null }
};

export const CountrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    fetchCountryListRequest: (country, action) => {
      country.countryList.loading = true;
      country.countryList.error = null;
    },
    fetchCountryListSuccess: (country, action) => {
      country.countryList.data = action.payload;
      country.countryList.loading = false;
      country.countryList.error = null;
    },
    fetchCountryListFailure: (country, action) => {
      country.countryList.data = null;
      country.countryList.loading = false;
      country.countryList.error = action.payload;
    }
  }
});

export const {
  fetchCountryListRequest,
  fetchCountryListSuccess,
  fetchCountryListFailure
} = CountrySlice.actions;

/**
 *
 * @param {*} store
 * @returns {CountryStoreCountry['countryList']}
 */
export const getCountryListState = (store) => store.country?.countryList;

export default CountrySlice.reducer;
